<template>
  <div>
    <canvas
      :id="`canvas-${number}`"
      width="500"
      height="500"
      class="border inline-block"
    >
      <p>Sorry, this game doesn't work without the Canvas Enabled</p>
    </canvas>

    <h1
      v-if="comparedPoints.correct"
      class="font-heading font-semibold text-4xl my-3"
    >
      Correct Route
    </h1>
    <h1 v-else class="font-heading font-semibold text-4xl my-3">
      Incorrect Route
    </h1>

    <div class="mb-4 mt-2">
      <button class="button-secondary mx-2 mt-2" @click="toggle('showDots')">
        Toggle Dots
      </button>
      <button
        class="button-secondary mx-2 mt-2"
        @click="toggle('showDrawnRoute')"
      >
        Toggle Drawn Route
      </button>
      <button
        class="button-secondary mx-2 mt-2"
        @click="toggle('showCorrectRoute')"
      >
        Toggle Correct Route
      </button>
    </div>
  </div>
</template>

<script>
import {
  drawRing,
  drawTriangle,
  drawPath,
  drawCircleWithRing,
  setLineStyle,
} from '@/scripts/CanvasDrawing'
import { comparePath } from '@/scripts/PathMatching'
import { findImageScale } from '@/scripts/ImageScale'

export default {
  props: {
    settings: {
      type: Object,
      default: () => ({}),
    },
    userPath: {
      type: Array,
      default: () => [],
    },
    number: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    canvas: undefined,
    canvasLocation: undefined,
    img: undefined,

    showCorrectRoute: true,
    showDrawnRoute: true,
    showDots: true,
  }),

  computed: {
    comparedPoints: function () {
      return comparePath(
        this.settings.compulsoryPoints,
        this.settings.disallowedPoints,
        this.userPath
      )
    },
  },
  mounted: function () {
    this.canvasElement = document.getElementById(`canvas-${this.number}`)
    this.canvas = this.canvasElement.getContext('2d')
    this.loadImage()
  },

  methods: {
    toggle: function (property) {
      this[property] = !this[property]
      this.onImageLoad()
    },

    loadImage: function () {
      this.wipeCanvas()
      this.img = new Image()
      this.img.onload = this.onImageLoad
      this.img.src = this.settings.imageLocation
    },

    onImageLoad: function () {
      const imageScale = this.settings?.scale || findImageScale(this.img)
      this.canvasElement.width = this.img.width * imageScale
      this.canvasElement.height = this.img.height * imageScale

      this.canvas.drawImage(
        this.img,
        0,
        0,
        this.canvasElement.width,
        this.canvasElement.height
      )

      this.imageLoaded = true
      this.drawPoints()
    },

    wipeCanvas: function () {
      this.canvas.clearRect(
        0,
        0,
        this.canvasElement.width,
        this.canvasElement.height
      )
    },

    drawPoints: function () {
      setLineStyle(this.canvas, 'purple')
      if (this.settings.startLocation)
        drawTriangle(this.canvas, this.settings.startLocation, 14)
      if (this.settings.finishLocation)
        drawRing(this.canvas, this.settings.finishLocation, 14)

      if (this.showDots) this.drawDots()
      if (this.showCorrectRoute)
        this.drawPath(this.settings.correctPath, 'blue', 6)
      if (this.showDrawnRoute) this.drawPath(this.userPath, 'purple', 6)
    },

    drawDots: function () {
      this.settings.compulsoryPoints.forEach((point, index) => {
        if (!this.comparedPoints?.compulsoryPoints?.[index])
          drawCircleWithRing(this.canvas, point.location, point.size - 1.5, [
            'blue-dark',
          ])
        else
          drawCircleWithRing(this.canvas, point.location, point.size - 1.5, [
            'blue',
            'dark-blue',
          ])
      })

      this.settings.disallowedPoints.forEach((point, index) => {
        if (this.comparedPoints?.disallowedPoints?.[index])
          drawCircleWithRing(this.canvas, point.location, point.size, [
            'red-dark',
          ])
        else
          drawCircleWithRing(this.canvas, point.location, point.size, [
            'red',
            'red-dark',
          ])
      })
    },

    drawPath: function (path, color = 'purple', width = 3.5) {
      setLineStyle(this.canvas, color, width)
      if (this.settings.startLocation)
        drawPath(this.canvas, [this.settings.startLocation, ...path])
    },
  },
}
</script>
<style>
canvas {
  align-self: center;
}
</style>
